/**
 * AuthButton - Primary button for auth forms
 */
import React from 'react';

function AuthButton({
  children,
  onClick,
  type = 'button',
  loading = false,
  disabled = false,
  variant = 'primary',
  fullWidth = true,
  className = '',
}) {
  const baseStyles = `
    py-2 px-6 rounded-xl font-normal text-base
    transition-all duration-200 flex items-center justify-center gap-2
    disabled:opacity-50 disabled:cursor-not-allowed
    active:scale-[0.98]
  `;
  
  const variants = {
    primary: `
      bg-gradient-to-r from-[#004171] to-[#003366] text-white
      hover:from-[#003366] hover:to-[#002855]
      shadow-lg shadow-[#004171]/20
    `,
    secondary: `
      bg-white text-[#004171] border-2 border-[#004171]
      hover:bg-[#004171]/5
    `,
    success: `
      bg-gradient-to-r from-[#22B14C] to-[#1a9a3f] text-white
      hover:from-[#1a9a3f] hover:to-[#158a35]
      shadow-lg shadow-[#22B14C]/20
    `,
    ghost: `
      bg-transparent text-[#004171]
      hover:bg-[#004171]/5
    `,
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {loading ? (
        <>
          <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
            <circle 
              className="opacity-25" 
              cx="12" cy="12" r="10" 
              stroke="currentColor" 
              strokeWidth="4" 
              fill="none" 
            />
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" 
            />
          </svg>
          <span>Please wait...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}

export default AuthButton;
